import { apiPaths } from '@services';
import carrickApi from '@services/carrickApi';
import { StartCarrickWorkflowArgs } from '../types';
import { carrickStartResponseMapper } from '../utils';

const extendedApi = carrickApi.injectEndpoints({
    endpoints: (builder) => ({
        startCarrickWorkflow: builder.mutation<
            string,
            StartCarrickWorkflowArgs
        >({
            query: (body) => ({
                url: apiPaths.send.carrickFlow(),
                method: 'POST',
                body,
                responseHandler: 'text',
            }),
            transformResponse: carrickStartResponseMapper,
        }),
    }),
});

export const { useStartCarrickWorkflowMutation } = extendedApi;
export default extendedApi.endpoints;
